var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import clsx from 'clsx';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const backgroundColors = [
    {
        background: '',
        type: 'solid',
        textColor: 'dark',
    },
    {
        background: 'red',
        type: 'solid',
        textColor: 'light',
    },
    {
        background: 'linear-gradient(to top, #654ea3, #eaafc8)',
        type: 'gradient',
        textColor: 'dark',
    },
    {
        background: 'linear-gradient(to top, #ee0979, #ff6a00)',
        type: 'gradient',
        textColor: 'light',
    },
];
export const FormControlBackgroundColorPicker = (_a) => {
    var { value, onChange } = _a, rest = __rest(_a, ["value", "onChange"]);
    const [activeBackground, setActiveBackground] = useState(value);
    const { layoutProps, inputProps } = extractLayoutProps(rest);
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps),
        React.createElement("div", Object.assign({ className: "flex space-s-2 flex-wrap" }, inputProps), backgroundColors.map(item => (React.createElement("div", { onClick: () => {
                onChange(item);
                setActiveBackground(item.background);
            }, key: item.background, className: clsx('w-9 h-9 rounded-full border-4 cursor-pointer', (activeBackground || '') === item.background
                ? 'border-line-subdued'
                : 'border-line-subdued hover:opacity-90'), style: { background: item.background } }))))));
};
//# sourceMappingURL=FormControlBackgroundColorPicker.js.map